import React, { Fragment } from "react";
import Modal from "react-modal";
import { FaTimes } from "react-icons/fa";
import "core-js/stable";
import "regenerator-runtime/runtime";

const SessionHOC = (WrappedComponent) => {
  return class Default extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        warningTime: 1000 * 60 * 29,
        signoutTime: 1000 * 60 * 30,
        seconds: 60,
        modalIsOpen: false,
      };
      this.getRemainingTime = this.getRemainingTime.bind(this);
      this.lastPing = new Date();
    }

    componentDidMount() {
      this.events = ["load", "mousedown", "click", "scroll", "keypress"];
      for (var i in this.events) {
        window.addEventListener(this.events[i], this.resetTimeout.bind(this));
      }
      this.setTimeout();
    }

    getRemainingTime() {
      let count = 60;
      this.timer = setInterval(() => {
        count--;
        if (count === 0) {
          this.setState(
            {
              seconds: count,
              modalIsOpen: false,
            },

            clearTimeout(this.timer)
          );
        }
        this.setState({ seconds: count });
      }, 1000);
    }

    clearTimeoutFunc = () => {
      if (this.warnTimeout) clearTimeout(this.warnTimeout);
      if (this.logoutTimeout) clearTimeout(this.logoutTimeout);
    };

    setTimeout = () => {
      if (this.state.modalIsOpen === false) {
        this.warnTimeout = setTimeout(this.warn, this.state.warningTime);
      }
      this.logoutTimeout = setTimeout(
        () => this.logout(null, "modal-logout-expired"),
        this.state.signoutTime
      );
    };

    resetTimeout = () => {
      this.clearTimeoutFunc();
      this.setTimeout();
      this.pingCheck();
    };

    handleCloseModal = () => {
      this.setState({ modalIsOpen: false });
      clearTimeout(this.timer);
      this.resetTimeout();
      this.pingCheck();
    };

    warn = () => {
      this.setState(
        {
          modalIsOpen: true,
        },
        function () {
          this.getRemainingTime();
        }
      );
    };

    logout = (e, action) => {
      e && e.preventDefault();
      this.destroy(action);
    };

    destroy = (action) => {
      window.location.assign(`/auth/auth/logout?action=${action}`);
    };

    pingCheck = () => {
      if (new Date() - this.lastPing > 60 * 1000) {
        this.lastPing = new Date();
        fetch("/auth/auth/ping");
      }
    };

    render() {
      return (
        <Fragment>
          <Modal
            portalClassName={"session-hoc"}
            isOpen={this.state.modalIsOpen}
            className="Modal modal-padding"
            overlayClassName="Overlay"
          >
            <button
              className="modal-empty-button modal-close"
              onClick={this.handleCloseModal}
            >
              <FaTimes size={"2em"} />
              <span className="usa-sr-only">Close modal</span>
            </button>

            <h3>Your session is about to expire!</h3>
            <p>
              You will be logged out in{" "}
              <span
                style={{
                  fontWeight: 700,
                  textDecoration: "underline",
                }}
              >
                {this.state.seconds}
              </span>{" "}
              seconds.
            </p>
            <p>Do you want to stay in?</p>
            <form>
              <button
                className="usa-button usa-button-secondary"
                onClick={(e) => this.logout(e, "modal-logout-clicked")}
              >
                Sign me out
              </button>
              <button
                className="usa-button usa-button-primary"
                onClick={this.handleCloseModal}
              >
                Keep me signed in
              </button>
            </form>
          </Modal>
          <WrappedComponent {...this.props} />
        </Fragment>
      );
    }
  };
};

export default SessionHOC;
